import axios from "axios";
import {
  onboardingProgressUrl,
  notifListUrl,
  notifUnreadCountUrl,
  notifMarkReadUrl,
  notifMarkAllReadUrl,
  notifPreferencesUrl,
  leadStatusesUrl,
  prioritizedLeadsUrl,
  leadStageUrl,
  leadNoteUrl,
  leadTimelineUrl,
  leadTasksForLeadUrl,
  createLeadTaskUrl,
  myTasksUrl,
  completeTaskUrl,
  cancelTaskUrl,
} from "../utils/urls";

// ---------- home / onboarding ----------
export const getOnboardingProgress = async () =>
  (await axios.get(onboardingProgressUrl))?.data?.data;

// ---------- notifications ----------
export const getNotifications = async (params = {}) =>
  (await axios.get(notifListUrl, { params }))?.data?.data;
export const getUnreadCount = async () =>
  (await axios.get(notifUnreadCountUrl))?.data?.data?.count ?? 0;
export const markNotifRead = async (id) => (await axios.patch(notifMarkReadUrl(id)))?.data;
export const markAllNotifRead = async () => (await axios.patch(notifMarkAllReadUrl))?.data;
export const getNotifPreferences = async () =>
  (await axios.get(notifPreferencesUrl))?.data?.data;
export const setNotifPreferences = async (prefs) =>
  (await axios.put(notifPreferencesUrl, prefs))?.data?.data;

// ---------- lead engagement ----------
export const getLeadStatuses = async () =>
  (await axios.get(leadStatusesUrl))?.data?.data;
export const getPrioritizedLeads = async () =>
  (await axios.get(prioritizedLeadsUrl))?.data?.data;
export const changeLeadStage = async (lprId, status_id) =>
  (await axios.patch(leadStageUrl(lprId), { status_id }))?.data?.data;
export const addLeadNote = async (lprId, note, kind = "note") =>
  (await axios.post(leadNoteUrl(lprId), { note, kind }))?.data?.data;
export const getLeadTimeline = async (lprId) =>
  (await axios.get(leadTimelineUrl(lprId)))?.data?.data;
export const getLeadTasks = async (lprId) =>
  (await axios.get(leadTasksForLeadUrl(lprId)))?.data?.data;
export const createTask = async (payload) =>
  (await axios.post(createLeadTaskUrl, payload))?.data?.data;
export const getMyTasks = async (params = {}) =>
  (await axios.get(myTasksUrl, { params }))?.data?.data;
export const completeTask = async (id) => (await axios.patch(completeTaskUrl(id)))?.data?.data;
export const cancelTask = async (id) => (await axios.patch(cancelTaskUrl(id)))?.data?.data;
